import { GoodsEcCategoryCodeComboBoxComponent } from './goods-ec-category-code-combo-box.component';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';


/**
 * 商品ECカテゴリ情報コンボボックスモデル
 *
 * @export GoodsEcCategoryCodeComboBoxModel
 * @class GoodsEcCategoryCodeComboBoxModel
 */
export class GoodsEcCategoryCodeComboBoxModel {

  public goodsEcCategoryList: Array<any> = Array<any>();
  public blank: boolean = <boolean>true;                                        // 先頭空白表示
  public component: GoodsEcCategoryCodeComboBoxComponent;                       // コンボボックスインスタンス
  public completeUpdateFlg: boolean = <boolean>false;                           // コードリスト取得完了
  public setCategoryCode: string = <string>'';                                  // 初期設定コード値

  // Note: 以降のメンバ変数は現行で明示的な宣言無し or HTML5の移植で必要になったメンバ
  public isInitOrderCode: boolean = <boolean>false;                             // 受注コード初期化済フラグ
  public initAutoLoad: boolean = <boolean>true;                                 // 初期データ自動取得フラグ
  public setSelectedIndex: number = <number>-1;                                 // 初期設定インデックス


  /**
   * 商品ECカテゴリ情報リストを更新する
   *
   * @param {*} serverData
   * @memberof GoodsEcCategoryCodeComboBoxModel
   */
  public updateGoodsEcCategoryList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData.CategoryList;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      const ob = {
        CategoryCode: '',
        CategoryName: '',
      };
      tempDataList.splice(index, 0, ob);
      index = 1;
    }

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
      const categoryCode: string = tempDataList[index].CategoryCode;
      tempDataList[index].CategoryName = categoryCode.substr(0, 3) + ':' + tempDataList[index].CategoryName;
    }

    this.goodsEcCategoryList = tempDataList;

    this.completeUpdateFlg = true;
    this.component.updateSelectedGoodsEcCategoryCode();
  }

}
